module.exports = __webpack_public_path__ + "img/esc_2_act_3.239ef47b.png";